import React from "react";
export const RecuperacionesContext = React.createContext({});
//default RecuperacionesContext;
